<template>
    <div v-if="showBanner && alert.text" ref="alert"  class="w-full bg-#2B2D42 text-white py-13px px-4 flex justify-center items-center">
      <div v-html="alert.text" class="font-roboto font-normal text-15px">
        
      </div>
      <a 
        v-if="alert.link && alert.button" 
        :href="alert.link" 
        target="_blank"
        class="bg-app-red-dark hover:bg-app-red-dark/80 text-white no-underline font-roboto font-medium text-14px py-5px px-18px rounded-md transition-colors ml-4 whitespace-nowrap"
      >
        {{ alert.button }}
      </a>
    </div>
  </template>
  
  <script>
  export default {
    props: ['alert'],
    data() {
      return {
        showBanner: false
      }
    },
    methods: {
      updateLayout() {
        if (!this.$refs.alert) return;
        
        const height = 90 + this.$refs.alert.clientHeight - 5;
        const menuleft = document.querySelector('.menuleft');
        if (menuleft) {
          menuleft.style.height = `calc(100% - ${height}px)`;
          menuleft.style.minHeight = `calc(100vh - ${height-20}px)`;
          menuleft.style.marginTop = `${height}px`;
        }
      }
    },
    watch: {
      'alert.active': {
        immediate: true,
        handler(newVal) {
          this.showBanner = newVal;
          if (newVal) {
            this.$nextTick(() => {
              this.updateLayout();
            });
          }
        }
      }
    },
    mounted() {
      if (this.alert && this.alert.active) {
        this.$nextTick(() => {
          this.updateLayout();
        });
      }
    }
  }
  </script>